import { render, staticRenderFns } from "./addmessage.vue?vue&type=template&id=16686a96&scoped=true"
import script from "./addmessage.vue?vue&type=script&lang=js"
export * from "./addmessage.vue?vue&type=script&lang=js"
import style0 from "./addmessage.vue?vue&type=style&index=0&id=16686a96&prod&scoped=true&lang=css"
import style1 from "./addmessage.vue?vue&type=style&index=1&id=16686a96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16686a96",
  null
  
)

export default component.exports